/**
 * The complaint-rate an app is visually flagged at in the dashboard. Matches the plan's
 * existing SES alarm threshold (0.05%); AWS itself starts a manual review nearer 0.1%.
 */
export const MAIL_COMPLAINT_RATE_FLAG = 0.0005;
/** UTC calendar day (`YYYY-MM-DD`) for a `Date` -- the key shape of an `APPSTAT#` row's SK. */
export function isoDay(d) {
    return d.toISOString().slice(0, 10);
}
/** The first calendar day (inclusive) covered by a trailing `windowDays`-day window ending on `asOf`. */
export function windowStartDay(asOf, windowDays) {
    const span = Math.max(1, windowDays);
    return isoDay(new Date(asOf.getTime() - (span - 1) * 86_400_000));
}
/**
 * Sum the daily rows that fall inside a trailing `windowDays`-day window ending on `asOf`
 * (both endpoints inclusive) and derive the two rates. Rows outside the window are ignored,
 * so the caller can pass every row it has for the widest window and re-roll narrower ones.
 */
export function rollupWindow(rows, windowDays, asOf) {
    const fromDay = windowStartDay(asOf, windowDays);
    const toDay = isoDay(asOf);
    let sends = 0;
    let deliveries = 0;
    let bounces = 0;
    let complaints = 0;
    for (const row of rows) {
        if (row.day < fromDay || row.day > toDay)
            continue;
        sends += row.sends;
        deliveries += row.deliveries;
        bounces += row.bounces;
        complaints += row.complaints;
    }
    return {
        windowDays,
        sends,
        deliveries,
        bounces,
        complaints,
        complaintRate: sends > 0 ? complaints / sends : null,
        bounceRate: sends > 0 ? bounces / sends : null,
    };
}
